import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
export const OccupancyTrendChart: React.FC = () => {
  // Sample data for occupancy trends over the last quarter
  const data = [{
    month: 'Apr',
    occupancy: 88.2,
    moveIns: 8,
    moveOuts: 6
  }, {
    month: 'May',
    occupancy: 89.5,
    moveIns: 10,
    moveOuts: 7
  }, {
    month: 'Jun',
    occupancy: 90.8,
    moveIns: 12,
    moveOuts: 8
  }, {
    month: 'Jul',
    occupancy: 91.2,
    moveIns: 9,
    moveOuts: 5
  }, {
    month: 'Aug',
    occupancy: 91.8,
    moveIns: 11,
    moveOuts: 8
  }, {
    month: 'Sep',
    occupancy: 92.4,
    moveIns: 14,
    moveOuts: 10
  }];
  return <ResponsiveContainer width="100%" height="100%" data-id="element-46">
      <LineChart data={data} margin={{
      top: 5,
      right: 30,
      left: 20,
      bottom: 5
    }} data-id="element-47">
        <CartesianGrid strokeDasharray="3 3" data-id="element-48" />
        <XAxis dataKey="month" data-id="element-49" />
        <YAxis yAxisId="left" domain={[85, 95]} data-id="element-50" />
        <YAxis yAxisId="right" orientation="right" domain={[0, 20]} data-id="element-51" />
        <Tooltip data-id="element-52" />
        <Legend data-id="element-53" />
        <Line yAxisId="left" type="monotone" dataKey="occupancy" name="Occupancy %" stroke="#1f58b0" activeDot={{
        r: 8
      }} strokeWidth={2} data-id="element-54" />
        <Line yAxisId="right" type="monotone" dataKey="moveIns" name="Move-Ins" stroke="#f6d052" strokeWidth={2} data-id="element-55" />
        <Line yAxisId="right" type="monotone" dataKey="moveOuts" name="Move-Outs" stroke="#f97c6b" strokeWidth={2} data-id="element-56" />
      </LineChart>
    </ResponsiveContainer>;
};